import "flowbite";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBolt } from "react-icons/fa";
import useNewProducts from "hook/useNewProduct";
import ProductCard from "components/ProductCard";

const FlashSale = () => {
  const navigate = useNavigate();
  const { newProducts } = useNewProducts();
  const [isVisible, setIsVisible] = useState(true);

  const getCountdown = (targetMs) => {
    const diff = Math.max(0, targetMs - Date.now());
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);
    return { days, hours, minutes, seconds };
  };

  const targetMs = useMemo(
    () => Date.now() + 3 * 24 * 60 * 60 * 1000 + 5 * 60 * 60 * 1000,
    [],
  );
  const [timeLeft, setTimeLeft] = useState(() => getCountdown(targetMs));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getCountdown(targetMs));
    }, 1000);
    return () => clearInterval(timer);
  }, [targetMs]);

  if (!isVisible) return null;

  return (
    <section className="sm:mt-10 mt-6 px-4 sm:px-6">
      {newProducts.length > 0 ? (
      <div className="rounded-lg overflow-hidden bg-gradient-to-r from-rose-600 via-orange-500 to-amber-500 p-4 text-white shadow-lg">
        <div className="mb-4 grid grid-cols-2 items-start gap-1">
          {/* Title */}
          <h3 className="flex items-center gap-2 font-extrabold text-lg sm:text-3xl">
            <FaBolt className="animate-bounce text-amber-200" />
            Flash Sale
          </h3>

          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => navigate("/hotOffer")}
              className="rounded-full bg-white/20 sm:px-4 px-3 ms:py-2 py-1 sm:text-sm text-xs font-semibold text-white backdrop-blur transition hover:bg-white/30"
            >
              View All
            </button>
          </div>

          {/* Description (next row, full width) */}
          <p className="col-span-2 text-sm text-rose-100 sm:text-base">
            Limited-time prices before the timer ends.
          </p>
        </div>

        <div className="mb-4 grid grid-cols-4 gap-2 sm:max-w-md">
          {[
            { label: "Days", value: timeLeft.days },
            { label: "Hours", value: timeLeft.hours },
            { label: "Minutes", value: timeLeft.minutes },
            { label: "Seconds", value: timeLeft.seconds },
          ].map((item) => (
            <div
              key={item.label}
              className="rounded-lg bg-black/20 px-2 py-2 text-center backdrop-blur"
            >
              <p className="font-extrabold sm:text-xl">
                {String(item.value).padStart(2, "0")}
              </p>
              <p className="text-[11px] uppercase tracking-wide text-rose-100 sm:text-xs">
                {item.label}
              </p>
            </div>
          ))}
        </div>

        <div className="flex snap-x gap-3 overflow-x-auto pb-2 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
          {newProducts
            .filter((item) => item.hideStatus === "available")
            .map((product) => (
              <ProductCard
                key={product.id}
                item={product}
                bgClass="bg-white/95"
                currencyClass="text-rose-600"
                textColor="text-slate-900"
              />
            ))}
        </div>
      </div>
      ) : null}
    </section>
  );
};

export default FlashSale;
